import { Card, Skeleton } from "@mantine/core";
import "./DatasetSkeletonCard.css";

export function DatasetSkeletonCard() {
  return (
    <Card className="dataset-skeleton-card">
      <Skeleton height={31} width={400} radius="sm" bg="background.0" />
      <Skeleton
        height={20}
        mt={3}
        width={50}
        radius="sm"
        color="background.0"
      />
      <Skeleton my={8} height={80} width="100%" radius="sm" c="background.0" />
    </Card>
  );
}
